import { Tag } from "antd";
import moment from "moment";
import { TransactionsDetails } from "../../types/statements";
import { capitalize } from "../../utils/string";
import { formatSouthAsianNumber } from "../../utils/utils";
import CustomModal from "../ui/CustomModal";
import emptyUser from "../../assets/images/empty_user.jpg";

interface ModalComponentProps<DataT = never, TypeT = never> {
  open: boolean;
  handleClose: (val?: any) => void;
  type?: "ADD" | "UPDATE" | "VIEW" | TypeT;
  data?: any;
  selectedCategory?: string;
}

const StatementDetailsModal = ({
  handleClose,
  type,
  data,
  selectedCategory,
  ...rest
}: ModalComponentProps<TransactionsDetails>) => {
  console.log("StatementDetailsModal data", data);

  // const statementDetails = [
  //   {
  //     label: "Zone",
  //     value: "Dhaka",
  //   },
  //   {
  //     label: "District",
  //     value: "Dhaka",
  //   },
  //   {
  //     label: "Date",
  //     value: data?.createdAt
  //       ? moment(data?.createdAt).format("DD/MM/YYYY")
  //       : "n/a",
  //   },
  //   {
  //     label: "Time",
  //     value: data?.createdAt
  //       ? moment(data?.createdAt).format("hh:mm A")
  //       : "n/a",
  //   },
  //   { label: "Business Unit", value: data?.businessUnit.name },
  //   { label: "Amount", value: "৳" + formatSouthAsianNumber(data?.amount || 0) },
  //   { label: "Sheba Pay Trx. ID", value: data?.transactionId },
  //   {
  //     label: "Sheba payment status",
  //     value: data?.status,
  //     isStatus: data?.status === "success" || "warning",
  //   },
  //   { label: "MR ID", value: data?.omrId },
  //   {
  //     label: "MR Status",
  //     value: data?.omrStatus,
  //     isStatus: data?.omrStatus === "success" || "warning",
  //   },
  //   { label: "Bank name", value: data?.businessUnit?.bankAccountName },
  //   { label: "Bank account", value: data?.businessUnit?.bankAccountNo },
  //   {
  //     label: "Bank Transfer",
  //     value: data?.mStatus,
  //     isStatus: data?.mStatus === "success" || "warning",
  //   },
  // ];

  const statementDetails =
    selectedCategory === "dealers"
      ? [
          { label: "Zone", value: data?.merchant?.zone ?? "N/A" },
          { label: "District", value: data?.merchant?.district ?? "N/A" },
          {
            label: "Date",
            value: data?.merchant?.createdAt
              ? moment(data?.merchant?.createdAt).format("DD/MM/YYYY")
              : "n/a",
          },
          {
            label: "Time",
            value: data?.merchant?.createdAt
              ? moment(data?.merchant?.createdAt).format("hh:mm A")
              : "n/a",
          },
          { label: "Business Unit", value: data?.businessUnit?.name ?? "N/A" },
          {
            label: "Amount",
            value: "৳" + formatSouthAsianNumber(data?.amount || 0),
          },
          { label: "Sheba Pay Trx. ID", value: data?.transactionId ?? "N/A" },
          {
            label: "Sheba payment status",
            value: data?.status,
            isStatus: true,
          },
          { label: "MR ID", value: data?.omrId ?? "N/A" },
          {
            label: "MR Status",
            value: data?.omrStatus,
            isStatus: true,
          },
          // {
          //   label: "Status Time",
          //   value: moment(data?.spayTransferAt).format("DD/MM/YYYY"),
          //   isStatus: true,
          // },
          {
            label: "Bank name",
            value: data?.businessUnit?.bankAccountName ?? "N/A",
          },
          {
            label: "Bank account",
            value: data?.businessUnit?.bankAccountNo ?? "N/A",
          },
          {
            label: "Bank Transfer",
            value: data?.mStatus,
            isStatus: true,
          },
        ]
      : [
          { label: "Zone", value: data?.suppliers?.zone ?? "N/A" },
          { label: "District", value: data?.suppliers?.district ?? "N/A" },
          {
            label: "Date",
            value: data?.createdAt
              ? moment(data.createdAt).format("DD/MM/YYYY")
              : "n/a",
          },
          {
            label: "Time",
            value: data?.createdAt
              ? moment(data.createdAt).format("hh:mm A")
              : "n/a",
          },
          { label: "Business Unit", value: data?.businessUnit?.name ?? "N/A" },
          {
            label: "Amount",
            value:
              "৳" +
              formatSouthAsianNumber(
                data?.tradersToSupplierTransactionAmount || 0
              ),
          },

          { label: "Tader Name", value: data?.profile?.merchantName ?? "N/A" },
          {
            label: "Tader Wallet Number",
            value: data?.profile?.merchantNumber ?? "N/A",
          },
          { label: "Sheba Pay Trx. ID", value: data?.transactionId ?? "N/A" },
          {
            label: "Sheba payment status",
            value: data?.status,
            isStatus: true,
          },
          { label: "MR ID", value: data?.omrId ?? "N/A" },
          {
            label: "MR Status",
            value: data?.omrStatus,
            isStatus: true,
          },
          // {
          //   label: "Status Time",
          //   value: data?.spayTransferAt,
          //   isStatus: true,
          // },
          {
            label: "Bank name",
            value: data?.businessUnit?.bankAccountName ?? "N/A",
          },
          {
            label: "Bank account",
            value: data?.businessUnit?.bankAccountNo ?? "N/A",
          },
          {
            label: "Bank Transfer",
            value: data?.mStatus,
            isStatus: true,
          },
        ];
  return (
    <CustomModal {...rest} handleClose={handleClose} width={460} footer={null}>
      {selectedCategory === "dealers" && (
        <div className="p-4">
          <div className="flex items-center space-x-3">
            <>
              <img
                src={data?.merchant?.profile?.logoImage}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div>
                <h2 className="text-lg font-semibold">{data?.merchant.name}</h2>
                <p className="text-gray-500 text-sm">
                  Dealer code: {data?.merchant.dealerNo}
                </p>
              </div>
            </>
          </div>
          <div className="mt-4 space-y-2 text-sm text-gray-700">
            <>
              {statementDetails.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2"
                  style={{
                    borderBottom:
                      index !== statementDetails.length - 1
                        ? "1px solid #E9EFF6"
                        : "none",
                  }}
                >
                  <div>{item.label}:</div>{" "}
                  {item.isStatus ? (
                    <Tag
                      color={
                        item?.value === "success" || item?.value === "approved"
                          ? "success"
                          : "warning"
                      }
                      className={`rounded-full`}
                      bordered={false}
                    >
                      {capitalize(
                        item?.value === "success"
                          ? "success"
                          : item?.value === "approved"
                          ? "approved"
                          : "pending"
                      )}
                    </Tag>
                  ) : (
                    item?.value || "n/a"
                  )}
                </div>
              ))}
            </>
          </div>
        </div>
      )}

      {selectedCategory === "traders" && (
        <div className="p-4">
          <div className="flex items-center space-x-3">
            <>
              <img
                src={emptyUser}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div>
                <h2 className="text-lg font-semibold">
                  {data?.suppliers?.name}
                </h2>
                <p className="text-gray-500 text-sm">
                  Dealer code: {data?.suppliers?.dealerCode}
                </p>
              </div>
            </>
          </div>
          <div className="mt-4 space-y-2 text-sm text-gray-700">
            <>
              {statementDetails.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2"
                  style={{
                    borderBottom:
                      index !== statementDetails.length - 1
                        ? "1px solid #E9EFF6"
                        : "none",
                  }}
                >
                  <div>{item.label}:</div>{" "}
                  {item.isStatus ? (
                    <Tag
                      color={
                        item?.value === "success" || item?.value === "approved"
                          ? "success"
                          : "warning"
                      }
                      className={`rounded-full`}
                      bordered={false}
                    >
                      {capitalize(
                        item?.value === "success"
                          ? "success"
                          : item?.value === "approved"
                          ? "approved"
                          : "pending"
                      )}
                    </Tag>
                  ) : (
                    item?.value || "n/a"
                  )}
                </div>
              ))}
            </>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default StatementDetailsModal;
